export default __webpack_public_path__ + "static/media/democratische-besluitvorming.e22db945.svg";